export const StylePropertiesEnum={
    sm:"sm",
    OK:"OK",
    OKCANCEL:"OKCANCEL",
    spin:"spin",
    Blue:"#005696",
    thirtyPx:"30px",
    fifteenPx:"15px",
    tweentyPx:"20px"

};